var api = "https://api.qingcigame.com";
var obj = {
    index: function() {
        this.preloading(); // 预加载
        this.indexBind(); // 首页按钮
        this.share(); // 分享
        this.isToken(); //重定向
    },
    isToken: function() {
        const url = new URL(window.location.href);

        // 检查是否有查询参数
        if (url.search) {
            // 移除查询参数
            url.search = '';
            // 重定向到没有参数的链接
            window.location.href = url.toString();
        };
    },
    // 图片资源预加载
    preloading: function() {
        //图片预加载
        var queue = new createjs.LoadQueue();
        queue.on("progress", function(e) {
            //加载中的进度
            if (e.progress * 100 >= 10) {
                $(".process-track .process-inner").width(parseInt(e.progress * 100) + '%');
                $(".process-percent #percent").html(parseInt(e.progress * 100));
            };
        }, this);
        queue.on("complete", function(e) {
            //加载完成执行操作
            $('.index').addClass('index-show');
            this.indexSwiper();
            setTimeout(function () {
                $('#preloading').fadeOut();
                setTimeout(function () {
                    $('#preloading').remove();
                }, 1000)
            }, 1000)
        }, this);
        queue.loadManifest([
            //加载图片，不包括后台的            
            '/card-pool-7/images/pc/preloading_bg-850ce42d4c.png',
            '/card-pool-7/images/pc/xk-5e51cbf613.png',
            '/card-pool-7/images/pc/logo-85cf3df37e.png',
            '/card-pool-7/images/pc/home_logo-5807ac3dd8.png',
            '/card-pool-7/images/pc/home_title-9602fb72e2.png',
            '/card-pool-7/images/pc/index_bg-00789b9229.png',
            '/card-pool-7/images/pc/code_img-4f5f355514.png',
            '/card-pool-7/images/pc/fanzhuan-2deb368194.png',
            '/card-pool-7/images/pc/fanzhuan_11-0bb9e53b55.png',
            '/card-pool-7/images/pc/footerbg-f2f8b1123f.png',
        ]);
    },
    // 首页轮播
    indexSwiper: function() {
        var mySwiper = new Swiper('.swiper-container', {
            pagination: '.swiper-pagination',
            direction: 'vertical',
            slidesPerView: 'auto',
            paginationClickable: true,
            spaceBetween: 0,
            mousewheel: true,
            resistanceRatio: 0,
            touchStartForcePreventDefault: true,
            paginationClickable: true,
            parallax: true,
            on: {
                init: function() {
                    swiperAnimate(this)
                },
                transitionStart: function() {
                    swiperAnimate(this);
                },
            },
        });
    },
    // 首页按钮
    indexBind: function() {
        var scene = document.getElementById('scene');
        var parallax = new Parallax(scene);
    },
    // 微信分享
    share: function() {
        var share_icon = 'https://download4.qcplay.com/qcgame-admin/dnX29EuzSenmU1Vt8cDJvCOGHofjdxkHtEs0Lzhm.png'
        var share_big_title = '《魔卡少女樱：回忆钥匙》';
        var share_min_title = '梦幻卡池「祈月之礼」';
        var share_link = window.location.href;
        outside.share(share_icon, share_big_title, share_min_title, share_link);
    },
    // 阿里云埋点
    countNum: function(data) {
        setTimeout(() => {
            try {
                __bl.sum(data);
            } catch (e) {
                // console.log(e)
            }
        }, 500);
    },
}